export const viewingQueryKeys = {
  _base: () => ["viewing"],
  all: (agencyId: string) => [...viewingQueryKeys._base(), { agencyId }],
  single: (agencyId: string, viewingId: string) => [
    ...viewingQueryKeys.all(agencyId),
    "single",
    { viewingId },
  ],
  byPerson: (agencyId: string, personId?: string) => [
    ...viewingQueryKeys.all(agencyId),
    "byPerson",
    { personId },
  ],
};
